const splitBase64Format = (base64String) => {
  const split_string = base64String.split(",");
  return split_string[1];
};

export default splitBase64Format;
